import { As, CardProps, Flex, Icon, Text } from '@chakra-ui/react';
import { Card, CardBody } from 'ui-components/dist/Card';

interface Props extends CardProps {
  label: string;
  icon: As;
}

export const DownloadCard: React.FC<Props> = ({ label, icon, ...props }) => (
  <Card
    width="100%"
    style={{ opacity: 0.5 }}
    _hover={{ opacity: 0.5 }}
    cursor="not-allowed"
    {...props}
  >
    <CardBody>
      <Flex width="100%" gap={2}>
        <Icon as={icon} boxSize={6} />
        <Text fontWeight="medium" fontSize="md">
          {label}
        </Text>
      </Flex>
    </CardBody>
  </Card>
);
